import { ConcreteFormStepProps } from './interfaces'
import { useTranslation } from 'react-i18next'
import { NextStep } from '../components/NextStep'
import { Box, Stack, TextField, Typography } from '@mui/material'
import React from 'react'
import { useStepForm } from './hooks'
import * as yup from 'yup'
import 'react-phone-number-input/style.css'
import { isValidPhoneNumber } from 'libphonenumber-js'
import { PhoneNumberInput } from '../components/PhoneNumberInput'
import { getCountryCallingCode } from 'react-phone-number-input'
import { getCompanyCountryCodeFor } from './utilities'

export const Ceo = ({ values, onSubmit, lead }: ConcreteFormStepProps) => {
    let defaultCountryCallingCode = ''
    if (getCompanyCountryCodeFor(lead)) {
        try {
            defaultCountryCallingCode = '+' + getCountryCallingCode(getCompanyCountryCodeFor(lead))
        } catch (e) {
        }
    }
    const { t } = useTranslation()
    const schema = yup.object({
        ceoPhoneNumber: yup.string().required().test({
            name: 'valid-phone',
            test (value, ctx) {
                return isValidPhoneNumber(value)
            }
        }),
        ceoMobilePhoneNumber: yup.string().nullable().test({
            name: 'valid-phone',
            skipAbsent: true,
            test (value, ctx) {
                return value === defaultCountryCallingCode
                    || isValidPhoneNumber(value ?? '')
            }
        })
    })
    const {
        control,
        handleSubmit,
        augmentedFieldProps
    } = useStepForm('Ceo', schema, {
        ...values,
        ceoPhoneNumber: values.ceoPhoneNumber && values.ceoPhoneNumber.length > 0 ? values.ceoPhoneNumber : defaultCountryCallingCode,
        ceoMobilePhoneNumber: values.ceoMobilePhoneNumber && values.ceoMobilePhoneNumber.length > 0 ? values.ceoMobilePhoneNumber : defaultCountryCallingCode,
    }, false)

    const onSubmitWithDataTransform = (data: Record<string, any>) => {
        onSubmit({
            ...data,
            ceoMobilePhoneNumber: data.ceoMobilePhoneNumber === defaultCountryCallingCode ? '' : data.mobilePhoneNumber
        })
    }

    return <>
        <Typography mb={4} variant="h5" component="h1">{t('Ceo.heading')}</Typography>

        <Box mb={3} maxWidth={500}>
            <TextField
                label={t('Ceo.fullName.label')}
                value={lead.firstName + ' ' + lead.lastName}
                disabled={true}
                fullWidth={true}
            />
        </Box>

        <form onSubmit={handleSubmit(onSubmitWithDataTransform)}>
            <Stack spacing={3} maxWidth={500}>
                <PhoneNumberInput control={control} fieldName="ceoPhoneNumber" componentName="Ceo"/>
                <PhoneNumberInput control={control} fieldName="ceoMobilePhoneNumber" componentName="Ceo"/>
            </Stack>

            <NextStep/>
        </form>
    </>
}
